export default "__VITE_ASSET__C5bVOp6v__"